import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";

const PALETTE = [
  { badge: "Top notes", title: "Citrus & aromatics", body: "Bergamot, mandarin, lemon, and green herbal notes provide the opening — fresh, bright, immediately recognisable." },
  { badge: "Heart notes", title: "Florals & spice", body: "Rose, jasmine, orange blossom, iris, saffron, and warm spice sit at the centre of most of our compositions." },
  { badge: "Base notes", title: "Woods, resins & musks", body: "Sandalwood, cedar, patchouli, amber, oud, tonka bean, and vanilla give each fragrance its long-wearing signature." },
];

const STANDARDS = [{
  heading: "Our standards",
  body: "We work with a curated palette of high-grade fragrance materials from established houses. Every batch is tested for stability, clarity, and scent integrity before it’s approved for bottling. We prefer to use fewer, better ingredients rather than long lists of filler.",
}];

const OILS = [{
  heading: "Pure oils & carrier ingredients",
  body: "Our extraits are alcohol-based; our pure-oil roll-ons are diluted in a cosmetic-grade fractionated coconut oil (caprylic/capric triglyceride) selected for its neutral scent, long shelf life, and gentle skin feel. Full ingredient lists appear on every product page.",
}];

const PACKAGING = [{
  heading: "Packaging materials",
  body: "Glass bottles, aluminium caps, and recyclable card cartons. We deliberately avoid plastic overwrap and unnecessary printed inserts. Where possible, cartons use inks and coatings compatible with municipal recycling programmes.",
}];

const NOTE = [{
  heading: "A note on “the world’s finest”",
  body: "We won’t claim we use the world’s finest anything — that phrase means nothing without proof. What we can say: our materials come from reputable suppliers, our formulas are refined until we’re proud to send them out, and our doors are open if you want to learn more. Email us with any specific question.",
}];

export default function SourcingPage() {
  return (
    <PageShell
      slug="sourcing"
      testid="sourcing"
      eyebrow="Ingredient Sourcing"
      title="An honest look at what’s in the bottle."
      intro="Scentodore compositions are built from a curated palette of French-inspired fragrance materials, blended and finished in Canada."
    >
      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Our fragrance palette</h2>
        <EditableFeatureGrid slug="sourcing" sectionKey="palette" fallback={PALETTE} />
      </div>
      <EditableSection slug="sourcing" sectionKey="standards" fallback={STANDARDS} />
      <EditableSection slug="sourcing" sectionKey="oils" fallback={OILS} />
      <EditableSection slug="sourcing" sectionKey="packaging" fallback={PACKAGING} />
      <EditableSection slug="sourcing" sectionKey="note" fallback={NOTE} />
    </PageShell>
  );
}
